export function computePOS(rgb) {

  const N = rgb.length;
  if (!N) return null;

  let sumR = 0, sumG = 0, sumB = 0;

  // 1️⃣ Compute mean
  for (let i = 0; i < N; i++) {
    sumR += rgb[i][0];
    sumG += rgb[i][1];
    sumB += rgb[i][2];
  }

  const meanR = sumR / N || 1;
  const meanG = sumG / N || 1;
  const meanB = sumB / N || 1;

  const X = new Float32Array(N);
  const Y = new Float32Array(N);

  let sumX = 0, sumY = 0;

  // 2️⃣ Compute X and Y + mean of X,Y
  for (let i = 0; i < N; i++) {

    const rn = rgb[i][0] / meanR;
    const gn = rgb[i][1] / meanG;
    const bn = rgb[i][2] / meanB;

    const x = 3 * rn - 2 * gn;
    const y = 1.5 * rn + gn - 1.5 * bn;

    X[i] = x;
    Y[i] = y;

    sumX += x;
    sumY += y;
  }

  const meanX = sumX / N;
  const meanY = sumY / N;

  let varX = 0, varY = 0;

  // 3️⃣ Compute variance
  for (let i = 0; i < N; i++) {
    const dx = X[i] - meanX;
    const dy = Y[i] - meanY;

    varX += dx * dx;
    varY += dy * dy;
  }

  const stdX = Math.sqrt(varX / N) || 1;
  const stdY = Math.sqrt(varY / N) || 1;

  const pos = new Float32Array(N);

  // 4️⃣ Final POS signal
  for (let i = 0; i < N; i++) {
    pos[i] = (X[i] / stdX) - (Y[i] / stdY);
  }

  return pos;
}


// export function computePOS(rgb) {

//   const N = rgb.length;
//   if (!N) return null;

//   let sumR = 0, sumG = 0, sumB = 0;

//   for (let i = 0; i < N; i++) {
//     sumR += rgb[i][0];
//     sumG += rgb[i][1];
//     sumB += rgb[i][2];
//   }

//   const meanR = sumR / N || 1;
//   const meanG = sumG / N || 1;
//   const meanB = sumB / N || 1;

//   const X = new Float32Array(N);
//   const Y = new Float32Array(N);

//   let sumX = 0, sumY = 0;

//   for (let i = 0; i < N; i++) {

//     const rn = rgb[i][0] / meanR;
//     const gn = rgb[i][1] / meanG;
//     const bn = rgb[i][2] / meanB;

//     const x = 3 * rn - 2 * gn;
//     const y = 1.5 * rn + gn - 1.5 * bn;

//     X[i] = x;
//     Y[i] = y;

//     sumX += x;
//     sumY += y;
//   }

//   const meanX = sumX / N;
//   const meanY = sumY / N;

//   let varX = 0, varY = 0;

//   for (let i = 0; i < N; i++) {
//     varX += (X[i] - meanX) ** 2;
//     varY += (Y[i] - meanY) ** 2;
//   }

//   const stdX = Math.sqrt(varX / N) || 1;
//   const stdY = Math.sqrt(varY / N) || 1;

//   const pos = new Float32Array(N);

//   for (let i = 0; i < N; i++) {
//     pos[i] = (X[i] / stdX) - (Y[i] / stdY);
//   }

//   // Remove DC
//   const meanPOS =
//     pos.reduce((sum, v) => sum + v, 0) / N;

//   for (let i = 0; i < N; i++) {
//     pos[i] -= meanPOS;
//   }

//   return pos;
// }

// export function computePOS(rgb) {

//   const N = rgb.length;
//   if (N < 10) return null;

//   let meanR=0, meanG=0, meanB=0;

//   for (let i=0;i<N;i++){
//     meanR+=rgb[i][0];
//     meanG+=rgb[i][1];
//     meanB+=rgb[i][2];
//   }

//   meanR/=N; meanG/=N; meanB/=N;

//   const X=[], Y=[];

//   for (let i=0;i<N;i++){

//     const rn=rgb[i][0]/meanR;
//     const gn=rgb[i][1]/meanG;
//     const bn=rgb[i][2]/meanB;

//     X.push(3*rn - 2*gn);
//     Y.push(1.5*rn + gn - 1.5*bn);
//   }

//   const stdX = Math.sqrt(X.reduce((s,v)=>s+v*v,0)/N);
//   const stdY = Math.sqrt(Y.reduce((s,v)=>s+v*v,0)/N);

//   return X.map((v,i)=> v/stdX - Y[i]/stdY);
// }
